<script setup>
import { computed, nextTick, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useUISettings } from 'dashboard/composables/useUISettings';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const store = useStore();
const router = useRouter();
const { uiSettings } = useUISettings();
const route = useRoute();

const agents = computed(() => store.getters['assistantAgents/getRecords']);

const isAgentPresent = agentId => {
  return !!agents.value.find(agent => agent.id === Number(agentId));
};

const routeToView = (name, params) => {
  router.replace({ name, params, replace: true });
};

const generateRouterParams = () => {
  const { last_active_assistant_agent_id: lastActiveAgentId } =
    uiSettings.value || {};

  if (isAgentPresent(lastActiveAgentId)) {
    return { agentId: lastActiveAgentId };
  }

  if (agents.value.length > 0) {
    const { id: agentId } = agents.value[0];
    return { agentId };
  }

  return null;
};

const routeToLastActiveAgent = () => {
  const params = generateRouterParams();

  // No agents found, redirect to the agents list page
  if (!params) {
    return routeToView('assistant_agents_index', {
      accountId: route.params.accountId,
    });
  }

  const { navigationPath } = route.params;
  const isAValidRoute = [
    'assistant_agents_scenarios_index', // Scenarios page
    'assistant_agents_playground_index', // Playground page
    'assistant_agents_inboxes_index', // Inboxes page
  ].includes(navigationPath);

  if (!isAValidRoute) {
    return routeToView('assistant_agents_index', {
      accountId: route.params.accountId,
    });
  }

  return routeToView(navigationPath, {
    accountId: route.params.accountId,
    ...params,
  });
};

const performRouting = async () => {
  await store.dispatch('assistantAgents/get');
  nextTick(() => routeToLastActiveAgent());
};

onMounted(() => performRouting());
</script>

<template>
  <div
    class="flex items-center justify-center w-full bg-n-surface-1 text-n-slate-11"
  >
    <Spinner />
  </div>
</template>
